<template>
  <div>
    <item v-for="(data, index) in model" :key="index" :model="data"/>
  </div>
</template>

<script>
import item from './Item'

export default {
  name: 'NtTreeView',
  components: {
    item
  },
  props: {
    model: Array
  }
}
</script>

<style>
.v-expansion-panel-header,
.v-expansion-panel-content__wrap {
  padding: 0px 0px 5px 12px !important;
}
.item {
  cursor: pointer;
}
.bold {
  font-weight: bold;
}
ul {
  padding-left: 1em;
  line-height: 1.5em;
  list-style-type: dot;
}
</style>
